// Purpose: small presentational components shared across Console dashboard screens.
//
// These were private to App.tsx, which prevented screens from being split into
// their own files. They hold no state and no data-fetching logic.

import type { ApiSipTrunk } from './apiClient';
import type { CallRow, ConsoleNumber } from './mockData';

export function MetricCard(props: { label: string; value: string; detail: string; tone?: 'good' | 'warn' }) {
  return <article className="metric-card"><span className="table-label">{props.label}</span><strong>{props.value}</strong><small className={props.tone ?? ''}>{props.detail}</small></article>;
}

export function EmptyState(props: { message: string }) {
  return <div className="empty-state">{props.message}</div>;
}

export type StatusPillStatus =
  | ConsoleNumber['state']
  | NonNullable<CallRow['status']>
  | ApiSipTrunk['provisioningStatus']
  | ApiSipTrunk['healthStatus'];

export function StatusPill(props: { status: StatusPillStatus }) {
  const label = props.status === 'Propagating' ? 'Provisioning' : props.status;
  return <span className={`status-pill ${props.status.toLowerCase().replace(/_/g, '-')}`}><i />{label}</span>;
}
